/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 * @author inspired by [jhildenbiddle](https://stackoverflow.com/a/48218209).
 * https://gist.github.com/ahtcx/0cd94e62691f539160b32ecda18af3d6#gistcomment-3120712
 */
export const mergeDeep = (target, source) => {
    const isObject = (obj) => obj && typeof obj === "object";
    if (!isObject(target) || !isObject(source)) {
        return source;
    }
    Object.keys(source).forEach((key) => {
        const k = key;
        const targetValue = target[k];
        const sourceValue = source[k];
        let newKey;
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            newKey = targetValue.concat(sourceValue);
        }
        else if (isObject(targetValue) && isObject(sourceValue)) {
            newKey = mergeDeep(Object.assign({}, targetValue), sourceValue);
        }
        else {
            newKey = sourceValue;
        }
        Object.assign(target, { [key]: newKey });
    });
    return target;
};
/**
 * Returns a new object with the falsy values removed.
 */
export const removeFalsy = (obj) => {
    const newObj = Object.assign({}, obj);
    Object.keys(newObj).forEach((key) => !newObj[key] && delete newObj[key]);
    return newObj;
};
//# sourceMappingURL=ObjectHelpers.js.map